module.exports = __webpack_public_path__ + "img/officeImg@2x.a8cf8e05.png";